export const TEMPER = Object.freeze({
  STOP: 0,
  RANDOM: 1,
  ATTACK: 2,
  ESCAPE: 3
})
